import { createContext } from 'react';
import { MappingContext } from '@decisions/server/DecisionsFramework/Design/Flow/Service';

export interface IDataDesignerContext {
  /**
   * Defines diagram name placeholder which will be shown when no name is set.
   */
  mappingContext?: MappingContext;
  noDiagramsMessage: string;
  noDiagramNameMessage: string;
}

export const DataDesignerContext = createContext<IDataDesignerContext>({
  noDiagramNameMessage: '',
  noDiagramsMessage: '',
});
